// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/app/resources/images/icons/alert_icon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TimeFrame Edit Styles (refactored) */
:root {
  --tfedit-spacing-lg: 1.5rem;
  --tfedit-spacing-md: 1rem;
  --tfedit-spacing-sm: 0.5rem;
  --tfedit-font-family: 'Source Sans Pro', sans-serif;
  --tfedit-font-size-lg: 1.125rem;
  --tfedit-font-size-md: 1rem;
  --tfedit-font-size-sm: 0.875rem;
  --tfedit-card-radius: 0.625rem;
  --tfedit-card-bg: var(--color-grey-96);
  --tfedit-card-bg: var(--color-grey-96);
  --tfedit-card-border: 1px solid var(--color-grey-91);
  --tfedit-card-border: 1px solid var(--color-grey-91);
}

.tfedit-card {
  background: var(--color-grey-96);
  background: var(--tfedit-card-bg);
  border-top: 1px solid var(--color-grey-91);
  border-top: var(--tfedit-card-border);
  border-bottom: 1px solid var(--color-grey-91);
  border-bottom: var(--tfedit-card-border);
  display: flex;
  flex-direction: column;
  padding: 0 1rem;
  position: relative;
  left: -1rem;
  margin-bottom: 1rem;
  margin-bottom: var(--tfedit-spacing-md);
  width: 104%;
}
.tfedit-content {
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  padding: var(--tfedit-spacing-lg);
  gap: 1rem;
  gap: var(--tfedit-spacing-md);
}
.tfedit-row {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  gap: var(--tfedit-spacing-sm);
  width: 100%;
}
.tf-cell {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.tf-wide-cell {
  flex: 1;
}
.tf-normal-cell {
  flex: 2;
}
.tf-narrow-cell {
  flex: 1.5;
}
.tfedit-field-start-hour {
  margin-right: 0.5rem;
  margin-right: var(--tfedit-spacing-sm);
}
.tfedit-select-menu {
  border: 1px solid var(--color-grey-91);
  border: 1px solid var(--color-grey-91);
}
.tfedit-row-1 {
  flex: 1 1 0;
  min-width: 0;
}
.tfedit-required {
  color: var(--color-status-alert-96);
  color: var(--color-status-alert-96);
  font-family: Source Sans Pro;
  font-weight: 900;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  margin-left: 1px;
}
.tfedit-label {
  font-family: 'Source Sans Pro', sans-serif;
  font-family: var(--tfedit-font-family);
  font-weight: 600;
  font-size: 0.875rem;
  font-size: var(--tfedit-font-size-sm);
  color: var(--color-grey-45);
  color: var(--color-grey-45);
  height: 20px;
}
.tfedit-input {
  height: 2.5rem;
  border: 1px solid var(--color-grey-91);
  border: 1px solid var(--color-grey-91);
  border-radius: 3px;
  background: var(--color-grey-100);
  background: var(--color-grey-100);
  padding: 0 0.5rem 0 1rem;
  font-family: 'Source Sans Pro', sans-serif;
  font-family: var(--tfedit-font-family);
  font-size: 1rem;
  font-size: var(--tfedit-font-size-md);
  color: var(--color-grey-45);
  color: var(--color-grey-45);
  outline: none;
  transition: border 0.2s;
  width: 5rem;
}
.tfedit-input:focus {
  border: 1.5px solid var(--color-primary-idel);
  border: 1.5px solid var(--color-primary-idel);
}
.tfedit-input-disabled {
  background: transparent;
  color: var(--color-disabled-95);
  color: var(--color-disabled-95);
  border: 1px solid var(--color-disabled-85);
  border: 1px solid var(--color-disabled-85);
}
.tfedit-error {
  background: var(--color-status-alert-100);
  background: var(--color-status-alert-100);
  border-radius: 3px;
  padding: 4px 16px 4px 8px;
  color: var(--color-status-alert-96);
  color: var(--color-status-alert-96);
  font-size: 14px;
  font-family: 'Source Sans Pro', sans-serif;
  font-family: var(--tfedit-font-family);
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}
.tfedit-error .tfedit-error-icon {
  width: 24px;
  height: 24px;
  display: inline-block;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center
    center;
  background-size: contain;
}
.tfedit-input-placeholder {
  color: var(--color-grey-71);
  color: var(--color-grey-71);
}
/* Clear ("x") button on the clearable end-date picker. react-datepicker ships
   it as a white glyph on a filled blue circle; override to a plain grey glyph
   with no background, matching the muted controls used elsewhere.
   Scoped under .tfedit-field (the LabelInput wrapper) so these rules outrank
   react-datepicker's own stylesheet, which is injected AFTER this file and
   would otherwise win on equal specificity. */
.tfedit-field .react-datepicker__close-icon {
  padding: 0 10px 0 0;
}
.tfedit-field .react-datepicker__close-icon::after {
  background-color: transparent;
  border-radius: 0;
  color: var(--color-grey-71);
  color: var(--color-grey-71);
  font-size: 18px;
  height: auto;
  width: auto;
  padding: 0;
}
.tfedit-field .react-datepicker__close-icon:hover::after {
  color: var(--color-grey-45);
  color: var(--color-grey-45);
}
.tfedit-source-wrap {
  display: flex;
  flex-direction: column;
  padding-top: 16px;
}
.tfedit-source-label {
  font-family: 'Source Sans Pro', sans-serif;
  font-family: var(--tfedit-font-family);
  font-size: 0.875rem;
  font-size: var(--tfedit-font-size-sm);
  color: var(--color-grey-45);
  color: var(--color-grey-45);
  font-weight: 400;
}
.tfedit-source-tag {
  background: var(--color-grey-96);
  background: var(--color-grey-96);
  color: var(--color-grey-45);
  color: var(--color-grey-45);
  border-radius: 3px;
  font-family: 'Source Sans Pro', sans-serif;
  font-family: var(--tfedit-font-family);
  font-size: 0.875rem;
  font-size: var(--tfedit-font-size-sm);
  font-weight: 600;
  cursor: pointer;
  border: none;
  display: inline-block;
}
.tfedit-source-tag[title]:hover {
  background: var(--color-grey-91);
  background: var(--color-grey-91);
}

/* Footer */
.tfedit-footer {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.tfedit-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-family: 'Source Sans Pro', sans-serif;
  font-family: var(--tfedit-font-family);
  font-weight: 600;
  border-radius: 4px;
  outline: none;
  width: 80px;
  height: 24px;
  border: none;
  cursor: pointer;
}
.tfedit-btn-done {
  background: var(--color-primary-idel);
  background: var(--color-primary-idel);
  color: var(--color-grey-100);
  color: var(--color-grey-100);
  border: none;
  color: white;
}
.tfedit-btn-done:hover,
.tfedit-btn-done:focus {
  background: var(--color-primary-hover);
  background: var(--color-primary-hover);
  color: var(--color-grey-100);
  color: var(--color-grey-100);
}
.tfedit-btn-done:disabled {
  background: var(--color-disabled-85);
  background: var(--color-disabled-85);
}
.tfedit-btn-cancel {
  background: transparent;
  color: var(--color-grey-45);
  color: var(--color-grey-45);
  border: 1px solid var(--color-grey-71);
  border: 1px solid var(--color-grey-71);
}
.tfedit-btn-cancel:hover,
.tfedit-btn-cancel:focus {
  background: var(--color-grey-98);
  background: var(--color-grey-98);
}
.tfedit-btn-cancel:active {
  background: var(--color-grey-71);
  background: var(--color-grey-71);
}

.tfedit-card {
  width: 105%;
  left: -1.5rem;
  padding: 0;
}

.tfedit-input-error {
  border: 1px solid var(--color-status-alert-96) !important;
  border: 1px solid var(--color-status-alert-96) !important;
}

.tfedit-tooltip {
  position: absolute;
  top: 120%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 160px;
  pointer-events: none;
}

.tfedit-tooltip-arrow {
  width: 12px;
  height: 6px;
  background: transparent;
  position: absolute;
  left: 50%;
  bottom: 100%;
  top: auto;
  transform: translateX(-50%);
  overflow: visible;
}
.tfedit-tooltip-arrow::after {
  content: '';
  display: block;
  width: 12px;
  height: 6px;
  background: transparent;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid var(--color-grey-45);
  border-bottom: 6px solid var(--color-grey-45);
  border-top: none;
}

.tfedit-tooltip-content {
  background: var(--color-grey-45);
  background: var(--color-grey-45);
  color: var(--color-grey-100);
  color: var(--color-grey-100);
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 14px;
  font-weight: 400;
  border-radius: 2px;
  box-shadow: 0px 3px 6px 0px rgba(28, 29, 32, 0.3);
  padding: 5px 8px 7px 8px;
  text-align: left;
  min-width: 160px;
  pointer-events: auto;
  white-space: pre-line;
}
`, "",{"version":3,"sources":["webpack://./app/styles/editField/TimeFrameEdit.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,mDAAmD;EACnD,+BAA+B;EAC/B,2BAA2B;EAC3B,+BAA+B;EAC/B,8BAA8B;EAC9B,sCAAsC;EACtC,sCAAsC;EACtC,oDAAoD;EACpD,oDAAoD;AACtD;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,0CAA0C;EAC1C,qCAAqC;EACrC,6CAA6C;EAC7C,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,uCAAuC;EACvC,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,iCAAiC;EACjC,SAAS;EACT,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,6BAA6B;EAC7B,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;AACT;AACA;EACE,OAAO;AACT;AACA;EACE,OAAO;AACT;AACA;EACE,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,sCAAsC;AACxC;AACA;EACE,sCAAsC;EACtC,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,2BAA2B;EAC3B,2BAA2B;EAC3B,YAAY;AACd;AACA;EACE,cAAc;EACd,sCAAsC;EACtC,sCAAsC;EACtC,kBAAkB;EAClB,iCAAiC;EACjC,iCAAiC;EACjC,wBAAwB;EACxB,0CAA0C;EAC1C,sCAAsC;EACtC,eAAe;EACf,qCAAqC;EACrC,2BAA2B;EAC3B,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,6CAA6C;EAC7C,6CAA6C;AAC/C;AACA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,0CAA0C;EAC1C,0CAA0C;AAC5C;AACA;EACE,yCAAyC;EACzC,yCAAyC;EACzC,kBAAkB;EAClB,yBAAyB;EACzB,mCAAmC;EACnC,mCAAmC;EACnC,eAAe;EACf,0CAA0C;EAC1C,sCAAsC;EACtC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB;UACQ;EACR,wBAAwB;AAC1B;AACA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;;;;;8CAK8C;AAC9C;EACE,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,2BAA2B;EAC3B,2BAA2B;EAC3B,eAAe;EACf,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;AACA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,mBAAmB;EACnB,qCAAqC;EACrC,2BAA2B;EAC3B,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,2BAA2B;EAC3B,2BAA2B;EAC3B,kBAAkB;EAClB,0CAA0C;EAC1C,sCAAsC;EACtC,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,sCAAsC;EACtC,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;AACA;EACE,qCAAqC;EACrC,qCAAqC;EACrC,4BAA4B;EAC5B,4BAA4B;EAC5B,YAAY;EACZ,YAAY;AACd;AACA;;EAEE,sCAAsC;EACtC,sCAAsC;EACtC,4BAA4B;EAC5B,4BAA4B;AAC9B;AACA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;AACA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,sCAAsC;EACtC,sCAAsC;AACxC;AACA;;EAEE,gCAAgC;EAChC,gCAAgC;AAClC;AACA;EACE,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,yDAAyD;EACzD,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,kCAAkC;EAClC,mCAAmC;EACnC,6CAA6C;EAC7C,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,4BAA4B;EAC5B,4BAA4B;EAC5B,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iDAAiD;EACjD,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB","sourcesContent":["/* TimeFrame Edit Styles (refactored) */\n:root {\n  --tfedit-spacing-lg: 1.5rem;\n  --tfedit-spacing-md: 1rem;\n  --tfedit-spacing-sm: 0.5rem;\n  --tfedit-font-family: 'Source Sans Pro', sans-serif;\n  --tfedit-font-size-lg: 1.125rem;\n  --tfedit-font-size-md: 1rem;\n  --tfedit-font-size-sm: 0.875rem;\n  --tfedit-card-radius: 0.625rem;\n  --tfedit-card-bg: var(--color-grey-96);\n  --tfedit-card-bg: var(--color-grey-96);\n  --tfedit-card-border: 1px solid var(--color-grey-91);\n  --tfedit-card-border: 1px solid var(--color-grey-91);\n}\n\n.tfedit-card {\n  background: var(--color-grey-96);\n  background: var(--tfedit-card-bg);\n  border-top: 1px solid var(--color-grey-91);\n  border-top: var(--tfedit-card-border);\n  border-bottom: 1px solid var(--color-grey-91);\n  border-bottom: var(--tfedit-card-border);\n  display: flex;\n  flex-direction: column;\n  padding: 0 1rem;\n  position: relative;\n  left: -1rem;\n  margin-bottom: 1rem;\n  margin-bottom: var(--tfedit-spacing-md);\n  width: 104%;\n}\n.tfedit-content {\n  display: flex;\n  flex-direction: column;\n  padding: 1.5rem;\n  padding: var(--tfedit-spacing-lg);\n  gap: 1rem;\n  gap: var(--tfedit-spacing-md);\n}\n.tfedit-row {\n  display: flex;\n  flex-direction: row;\n  gap: 0.5rem;\n  gap: var(--tfedit-spacing-sm);\n  width: 100%;\n}\n.tf-cell {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n.tf-wide-cell {\n  flex: 1;\n}\n.tf-normal-cell {\n  flex: 2;\n}\n.tf-narrow-cell {\n  flex: 1.5;\n}\n.tfedit-field-start-hour {\n  margin-right: 0.5rem;\n  margin-right: var(--tfedit-spacing-sm);\n}\n.tfedit-select-menu {\n  border: 1px solid var(--color-grey-91);\n  border: 1px solid var(--color-grey-91);\n}\n.tfedit-row-1 {\n  flex: 1 1 0;\n  min-width: 0;\n}\n.tfedit-required {\n  color: var(--color-status-alert-96);\n  color: var(--color-status-alert-96);\n  font-family: Source Sans Pro;\n  font-weight: 900;\n  font-size: 14px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  margin-left: 1px;\n}\n.tfedit-label {\n  font-family: 'Source Sans Pro', sans-serif;\n  font-family: var(--tfedit-font-family);\n  font-weight: 600;\n  font-size: 0.875rem;\n  font-size: var(--tfedit-font-size-sm);\n  color: var(--color-grey-45);\n  color: var(--color-grey-45);\n  height: 20px;\n}\n.tfedit-input {\n  height: 2.5rem;\n  border: 1px solid var(--color-grey-91);\n  border: 1px solid var(--color-grey-91);\n  border-radius: 3px;\n  background: var(--color-grey-100);\n  background: var(--color-grey-100);\n  padding: 0 0.5rem 0 1rem;\n  font-family: 'Source Sans Pro', sans-serif;\n  font-family: var(--tfedit-font-family);\n  font-size: 1rem;\n  font-size: var(--tfedit-font-size-md);\n  color: var(--color-grey-45);\n  color: var(--color-grey-45);\n  outline: none;\n  transition: border 0.2s;\n  width: 5rem;\n}\n.tfedit-input:focus {\n  border: 1.5px solid var(--color-primary-idel);\n  border: 1.5px solid var(--color-primary-idel);\n}\n.tfedit-input-disabled {\n  background: transparent;\n  color: var(--color-disabled-95);\n  color: var(--color-disabled-95);\n  border: 1px solid var(--color-disabled-85);\n  border: 1px solid var(--color-disabled-85);\n}\n.tfedit-error {\n  background: var(--color-status-alert-100);\n  background: var(--color-status-alert-100);\n  border-radius: 3px;\n  padding: 4px 16px 4px 8px;\n  color: var(--color-status-alert-96);\n  color: var(--color-status-alert-96);\n  font-size: 14px;\n  font-family: 'Source Sans Pro', sans-serif;\n  font-family: var(--tfedit-font-family);\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 8px;\n}\n.tfedit-error .tfedit-error-icon {\n  width: 24px;\n  height: 24px;\n  display: inline-block;\n  background: url('/app/resources/images/icons/alert_icon.svg') no-repeat center\n    center;\n  background-size: contain;\n}\n.tfedit-input-placeholder {\n  color: var(--color-grey-71);\n  color: var(--color-grey-71);\n}\n/* Clear (\"x\") button on the clearable end-date picker. react-datepicker ships\n   it as a white glyph on a filled blue circle; override to a plain grey glyph\n   with no background, matching the muted controls used elsewhere.\n   Scoped under .tfedit-field (the LabelInput wrapper) so these rules outrank\n   react-datepicker's own stylesheet, which is injected AFTER this file and\n   would otherwise win on equal specificity. */\n.tfedit-field .react-datepicker__close-icon {\n  padding: 0 10px 0 0;\n}\n.tfedit-field .react-datepicker__close-icon::after {\n  background-color: transparent;\n  border-radius: 0;\n  color: var(--color-grey-71);\n  color: var(--color-grey-71);\n  font-size: 18px;\n  height: auto;\n  width: auto;\n  padding: 0;\n}\n.tfedit-field .react-datepicker__close-icon:hover::after {\n  color: var(--color-grey-45);\n  color: var(--color-grey-45);\n}\n.tfedit-source-wrap {\n  display: flex;\n  flex-direction: column;\n  padding-top: 16px;\n}\n.tfedit-source-label {\n  font-family: 'Source Sans Pro', sans-serif;\n  font-family: var(--tfedit-font-family);\n  font-size: 0.875rem;\n  font-size: var(--tfedit-font-size-sm);\n  color: var(--color-grey-45);\n  color: var(--color-grey-45);\n  font-weight: 400;\n}\n.tfedit-source-tag {\n  background: var(--color-grey-96);\n  background: var(--color-grey-96);\n  color: var(--color-grey-45);\n  color: var(--color-grey-45);\n  border-radius: 3px;\n  font-family: 'Source Sans Pro', sans-serif;\n  font-family: var(--tfedit-font-family);\n  font-size: 0.875rem;\n  font-size: var(--tfedit-font-size-sm);\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n  display: inline-block;\n}\n.tfedit-source-tag[title]:hover {\n  background: var(--color-grey-91);\n  background: var(--color-grey-91);\n}\n\n/* Footer */\n.tfedit-footer {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n}\n\n.tfedit-btn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 12px;\n  font-family: 'Source Sans Pro', sans-serif;\n  font-family: var(--tfedit-font-family);\n  font-weight: 600;\n  border-radius: 4px;\n  outline: none;\n  width: 80px;\n  height: 24px;\n  border: none;\n  cursor: pointer;\n}\n.tfedit-btn-done {\n  background: var(--color-primary-idel);\n  background: var(--color-primary-idel);\n  color: var(--color-grey-100);\n  color: var(--color-grey-100);\n  border: none;\n  color: white;\n}\n.tfedit-btn-done:hover,\n.tfedit-btn-done:focus {\n  background: var(--color-primary-hover);\n  background: var(--color-primary-hover);\n  color: var(--color-grey-100);\n  color: var(--color-grey-100);\n}\n.tfedit-btn-done:disabled {\n  background: var(--color-disabled-85);\n  background: var(--color-disabled-85);\n}\n.tfedit-btn-cancel {\n  background: transparent;\n  color: var(--color-grey-45);\n  color: var(--color-grey-45);\n  border: 1px solid var(--color-grey-71);\n  border: 1px solid var(--color-grey-71);\n}\n.tfedit-btn-cancel:hover,\n.tfedit-btn-cancel:focus {\n  background: var(--color-grey-98);\n  background: var(--color-grey-98);\n}\n.tfedit-btn-cancel:active {\n  background: var(--color-grey-71);\n  background: var(--color-grey-71);\n}\n\n.tfedit-card {\n  width: 105%;\n  left: -1.5rem;\n  padding: 0;\n}\n\n.tfedit-input-error {\n  border: 1px solid var(--color-status-alert-96) !important;\n  border: 1px solid var(--color-status-alert-96) !important;\n}\n\n.tfedit-tooltip {\n  position: absolute;\n  top: 120%;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 160px;\n  pointer-events: none;\n}\n\n.tfedit-tooltip-arrow {\n  width: 12px;\n  height: 6px;\n  background: transparent;\n  position: absolute;\n  left: 50%;\n  bottom: 100%;\n  top: auto;\n  transform: translateX(-50%);\n  overflow: visible;\n}\n.tfedit-tooltip-arrow::after {\n  content: '';\n  display: block;\n  width: 12px;\n  height: 6px;\n  background: transparent;\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-bottom: 6px solid var(--color-grey-45);\n  border-bottom: 6px solid var(--color-grey-45);\n  border-top: none;\n}\n\n.tfedit-tooltip-content {\n  background: var(--color-grey-45);\n  background: var(--color-grey-45);\n  color: var(--color-grey-100);\n  color: var(--color-grey-100);\n  font-family: 'Source Sans Pro', sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  border-radius: 2px;\n  box-shadow: 0px 3px 6px 0px rgba(28, 29, 32, 0.3);\n  padding: 5px 8px 7px 8px;\n  text-align: left;\n  min-width: 160px;\n  pointer-events: auto;\n  white-space: pre-line;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
